var userInfo = null
var editMode = false

var init = function () {
  $('.spin').show()

  $.get('/api/users/me', function (data) {
    userInfo = data
    setProfileInformation ();
    $('.spin').hide()
  })

  showMode ()
}

var setProfileInformation = function () {
  document.getElementById('first_name').value = userInfo.first_name
  document.getElementById('last_name').value = userInfo.last_name
  document.getElementById('email').value = userInfo.email
}

var showMode = function () {
  document.getElementById('edit-user-text').innerHTML = editMode ? 'Save' : 'Edit'
  $('#edit-user i').attr('class', 'fa fa-' + (editMode ? 'floppy-o' : 'edit'))

  $('.editable').attr('disabled', !editMode)
  $('.edit-only').css('display', editMode === true ? 'block' : 'none')

  $('.edit-only.empty').val('')
  $('.display-ib').css('display', editMode === true ? 'inline-block' : 'none')
  $('.display-flex').css('display', editMode === true ? 'flex' : 'none')

  if (userInfo) {
    let resets = $('.reset')
    for (let i = 0; i < resets.length; i++) {
      if (userInfo[resets[i].id])
        resets[i].value = userInfo[resets[i].id]
      else
        resets[i].value = ''
    }
  }
}

var saveProfile = function () {
  let editables = getValues($('.editable.required'))
  let postData = validateInputs(editables)
  if (postData) {
    $('.spin').show()
    if (postData !== 'error') {
      if (postData.password) {
        postData.old_password = document.getElementById('old_password').value
      }
      document.getElementById('form-validate').innerHTML = ''
      $.post({
        url: '/api/users/update',
        data: JSON.stringify(postData),
        dataType: 'json',
        contentType: 'application/json; charset=utf-8'
      }).done(function (res) {
        if (res.ok) {
          for (let key in postData) {
            userInfo[key] = key === 'password' ? '' : postData[key]
          }
          cancelEdit ()
        } else {
          showCustomError ('Password is not correct')
        }
      }).fail(function (err) {
        let error = err.responseJSON.message ? err.responseJSON.message : 'Something went wrong, try again later'
        showCustomError (error)
      }).always(function () {
        $('.spin').hide()
      })

    } else {
      $('.spin').hide()
    }
  } else {
    cancelEdit ()
  }
}

var switchMode = function () {
  if (editMode) {
    saveProfile ()
  } else {
    editMode = !editMode
    showMode ()
  }
}

var validateInputs = function (inputs) {
  let ret = {}
  let hasKey = false
  for (let key in inputs) {
    if (inputs[key] === userInfo[key])
      continue
    let confirm = document.getElementById(key + '_confirm');
    if (confirm) {
      if (confirm.value !== inputs[key]) {
        showConfirmError(key)
        return 'error'
      }
    }
    if (key !== 'password' && inputs[key] === '') {
      showCustomError(getNameFromId(key) + ' fields required')
      return 'error'
    }
    if (key === 'password' && inputs[key] !== '') {
      if (document.getElementById('old_password').value === '') {
        showCustomError(getNameFromId('old_password') + ' fields required')
        return 'error'
      }
    }
    if (inputs[key] !== '') {
      ret[key] = inputs[key]
      hasKey = true
    }
  }
  return hasKey ? ret : null
}

var getValues = function (ary) {
  let ret = {}
  for (let i = 0; i < ary.length; i++) {
    ret[ary[i].id] = ary[i].value
  }
  return ret
}

var getNameFromId = function(id) {
  let ret = ''
  let keys = id.split('_')

  for (let i = 0; i < keys.length; i++) {
    ret += keys[i][0].toUpperCase() + keys[i].substr(1) + (i ? '' : ' ')
  }
  return ret.trim()
}

var Errors = [
  '"<valData>" is required',
  '"<valData>" is invalid'
]

var showConfirmError = function(key) {
  let els = []
  els.push(document.getElementById(key))
  els.push(document.getElementById(key + '_confirm'))

  for (let i = 0; i < els.length; i++) {
    let element = els[i]
    $(element).addClass('invalid')
    $(element).unbind('change')
    $(element).on('change', function() {
      $(els[0]).removeClass('invalid')
      $(els[1]).removeClass('invalid')
    })
  }
  
  var div = document.getElementById('form-validate')
  var errorId = (new Date()).getTime()
  var error = '<div id="er-' + errorId + '">' + getNameFromId(key) +' does not match' + '</div>'
  div.innerHTML += error

  setTimeout(function() {
    $('#er-' + errorId).remove()
  }, 3500)
}

var showCustomError = function(message) {
  var div = document.getElementById('form-validate')
  var errorId = (new Date()).getTime()
  var error = '<div id="er-' + errorId + '">' + message + '</div>'
  div.innerHTML += error

  setTimeout(function() {
    $('#er-' + errorId).remove()
  }, 3500)
}

var showValidationError = function (element, type) {
  $(element).addClass('invalid')
  $(element).unbind('change')
  $(element).on('change', function() {
    $(this).removeClass('invalid')
  })

  var div = document.getElementById('form-validate')
  var errorId = (new Date()).getTime()
  var error = '<div id="er-' + errorId + '">' + Errors[type] + '</div>'
  error = error.replace('<valData>', element.placeholder)
  div.innerHTML += error

  setTimeout(function() {
    $('#er-' + errorId).remove()
  }, 3500)
}

var cancelEdit = function () {
  editMode = !editMode
  showMode ()
}

document.getElementById('edit-user').addEventListener('click', switchMode)
document.getElementById('cancel-edit').addEventListener('click', cancelEdit)

init ()